<template>

    <div class="about">
        <div class="head">
            <div class="name">
                <div class="oimg">
                    <img src="../assets/img/logo.png" alt />
                </div>
                <div class="spa">e博视智慧配电在线监测系统</div>
            </div>
            <div class="tatel">
                <div class="miti">
                    <!-- <i class="el-icon-warning"></i> -->
                </div>
                <div class="mixin">{{ title }}</div>
            </div>
        </div>
        <div class="about1">
            <div class="left-hand">
                <div class="Pngfute">
                    <div class="oimg">
                        <!-- :src="src" -->
                        <iframe ref="iframe" width="100%" height="100%" class="small" :src="src"
                            frameborder="0"></iframe>
                    </div>
                </div>
                <div class="state">
                    <div class="setState">
                        <div class="setState1" v-show="!faultStatus">
                            <div>控制状态：</div>
                            <div v-if="Yufa == 'True'||Yufa >0" class="setState2">
                                {{ yuan }}
                            </div>
                            <div v-else-if="Yufa == 'False'||Yufa <=0" class="setState3">
                                {{ jiu }}
                            </div>
                            <div v-else class="setState4">
                                - -
                            </div>
                        </div>
                        <div v-show="faultStatus" class="setState1">
                            <div>控制状态：</div>
                            <div class="setState4">
                                - -
                            </div>
                        </div>
                        <div class="setState1">
                            回路状态：
                            <p v-if="statul" :class="st">{{ statul }}</p>
                            <p v-else style="color: #999999">- -</p>
                            <div class="gzzt" v-show="faultStatus">
                                <img src="../assets/img/gzzt.png" alt="" />故障状态
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bar">
                    <div :class="onage" @click="onClo">
                        <el-progress :width="80" class="progressHe" type="circle" :percentage="percentageHe">
                        </el-progress>
                        <span class="text-btn">{{ Hez }}</span>
                    </div>
                    <div :class="onChan" @click="onPo">
                        <el-progress class="progressFn" :width="80" type="circle" :percentage="percentageFn">
                        </el-progress>
                        <span class="text-btn">{{ Fnz }}</span>
                    </div>
                    <!-- <div class="popo"></div> -->
                </div>
            </div>
            <!-- <div class="javafort" v-if="Isshow != 0"> -->
            <div class="fors">
                <div class="middle">
                    <div class="table">
                        <el-table :row-style="{ height: '54rem' }" :header-cell-style="tableHeaderColor"
                            :row-class-name="tableRowClassName" :data="Data" border prop="name"
                            style="font-size: 18rem">
                            <el-table-column header-row-class-name="tableHead" prop="name" width="105">
                            </el-table-column>
                            <el-table-column prop="amount1" label="A/ab"></el-table-column>
                            <el-table-column prop="amount2" label="B/bc"></el-table-column>
                            <el-table-column prop="amount3" label="C/ac"></el-table-column>
                            <el-table-column prop="amount4" label="总"></el-table-column>
                            <el-table-column prop="spanw" label="单位"></el-table-column>
                        </el-table>
                    </div>

                    <div class="trigger">
                        <div class="swtrGet" @click="clikcLoopAll()" type="primary" style="margin-left: 16rem">
                            <i class="el-icon-sort"></i> 回路切换
                        </div>
                        <el-drawer title="回路" :visible.sync="drawer" :with-header="false">
                            <ul class="infinite-list" style="overflow:auto">
                                <div class="upward" @click="roll(1)">
                                    <i class="el-icon-arrow-up"></i>
                                </div>
                                <div ref="nav" @mousewheel="scrool" v-dragscroll class="vue-drag-scroll-out-wrapper">
                                    <div class="vue-drag-scroll-wrapper" :style="zoomStye">
                                        <li v-on:click="add(item.loopId, item)" v-for="item in bgonClick" class="jadk"
                                            :key="item.loopId" v-bind:class="{ array: item.loopId == current }">
                                            {{ item.loopName }}
                                        </li>
                                        <li class="npiNum" v-if="bgonClick.length">没有更多了</li>
                                        <li class="nonum" v-else>
                                            <div>
                                                <img src="../assets/img/not_found_data.png" alt />
                                            </div>
                                            暂无数据
                                        </li>
                                    </div>
                                </div>
                                <div class="downward" @click="roll(2)">
                                    <i class="el-icon-arrow-down"></i>
                                </div>
                            </ul>
                        </el-drawer>
                    </div>
                </div>
                <div class="dexter">
                    <div class="oia">
                        <div class="myCharts" ref="echartsDom"></div>
                    </div>
                    <div class="oib">
                        <div class="myCharts1" ref="echartsDom1"></div>
                    </div>

                    <div class="opl">
                        <ul class="PngUl">
                            <li class="pngLi">
                                <p class="pink"></p>
                                <p>总负载率:{{ this.totalAll ? this.totalAll : 0 }}%</p>
                            </li>
                            <li class="pngLi">
                                <p class="gruen"></p>
                                <p>回路负载率:{{ this.itemP ? this.itemP : 0 }}%</p>
                            </li>
                        </ul>
                        <div class="myCharts2" ref="echartsDom2"></div>
                        <div class="myCharts2-text">
                            {{ this.totalAll ? this.totalAll : "      0" }}
                        </div>
                        <div class="myCharts3-text">
                            总负载率
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="mar" >
      <div class="tors">
        <img src="../assets/img/not_found_data.png" alt />
        <div class="oP">
          暂无数据，请尝试
          <span class="antfos" @click="forsClick()" style="color: #0d94ff"
            >刷新</span
          >或切换日期
        </div>
      </div>
    </div> -->
        </div>
    </div>
</template>
<script>
    let echarts = require("echarts");
    import chainIndex from "../api/play";
    import {
        connect as connectMqtt,
        subscribe,
        unsubscribe,
        publishFun,
    } from "../mqtt/index";
    export default {
        name: "about",
        data() {
            return {
                current: "",
                yuan: "远方",
                jiu: "就地",
                title: "---暂未选择任何回路---",
                //echatr
                num: 10,
                error: "",
                //故障状态
                faultStatus: "",
                hours: [],
                //就地远方状态
                locallyStatus: "",
                //状态数字
                statusNum: "",
                FnzNum: "",
                HezNum: "",
                itemP: "",
                totalAll: "",
                width: 80,
                //合分闸倒计时
                Hez: "合闸",
                Fnz: "分闸",
                //倒计时
                timerJack: 6,
                timecuke: 5,
                percentageHe: 0,
                percentageFn: 0,
                //初始Id
                titleId: "205",
                //报警事件传值
                loop: "",
                //表格初始值
                titleAll: "",
                //上拉下滑
                scale: 100,
                // 接口是否有值
                //   Isshow: 0,
                //回路弹窗状态
                drawer: false,
                //回路颜色
                st: "ogreen",
                // 回路状态
                statul: "",
                loopData: {},
                src: "",
                //回路切换
                bgonClick: [],
                //分闸合闸
                onChan: "po",
                onage: "po",

                dialogVisible: false,
                Onchant: false,
                //echarte图形
                myChart: null,
                myChart1: null,
                myChart2: null,
                tableData: [],
                timer: "",
            };
        },
        computed: {
            infoSts() {
                return this.$store.getters.mqttVal(this.error);
            },
            Yufa() {
                return this.$store.getters.mqttVal(this.locallyStatus);
            },
            //手动拖拽回路切换
            zoomStye() {
                //  const INIT_WIDTH = 2208
                const INIT_HEIGHT = 1206;
                //  const width = INIT_WIDTH * (1 + (100 - this.scale)/100)
                const height = INIT_HEIGHT * (1 + (100 - this.scale) / 100);

                return {
                    // width: `${width}rem`,
                    height: `${height}rem`,
                    transform: `scale(${this.scale / 100})`,
                };
            },

            //TABLE数值
            Data() {
                // let a=this.titleAll.split('/')
                return [{
                        id: "1",
                        name: "相电压",
                        amount1: this.$store.getters.mqttVal(this.titleAll + "/Ua") ?
                            Math.floor(
                                this.$store.getters.mqttVal(this.titleAll + "/Ua") * 100
                            ) / 100 : "--",
                        amount2: this.$store.getters.mqttVal(this.titleAll + "/Ub") ?
                            Math.floor(
                                this.$store.getters.mqttVal(this.titleAll + "/Ub") * 100
                            ) / 100 : "--",
                        amount3: this.$store.getters.mqttVal(this.titleAll + "/Uc") ?
                            Math.floor(
                                this.$store.getters.mqttVal(this.titleAll + "/Uc") * 100
                            ) / 100 : "--",
                        amount4: "--",
                        spanw: "v",
                    },
                    {
                        id: "2",
                        name: "线电压",
                        amount4: "--",
                        amount1: this.$store.getters.mqttVal(this.titleAll + "/Uab") ?
                            Math.floor(
                                this.$store.getters.mqttVal(this.titleAll + "/Uab") * 100
                            ) / 100 : "--",
                        amount2: this.$store.getters.mqttVal(this.titleAll + "/Ubc") ?
                            Math.floor(
                                this.$store.getters.mqttVal(this.titleAll + "/Ubc") * 100
                            ) / 100 : "--",
                        amount3: this.$store.getters.mqttVal(this.titleAll + "/Uac") ?
                            Math.floor(
                                this.$store.getters.mqttVal(this.titleAll + "/Uac") * 100
                            ) / 100 : "--",

                        spanw: "v",
                    },
                    {
                        id: "3",
                        name: "电流",
                        amount1: this.$store.getters.mqttVal(this.titleAll + "/Ia") ?
                            Math.floor(
                                this.$store.getters.mqttVal(this.titleAll + "/Ia") * 100
                            ) / 100 : "--",
                        amount2: this.$store.getters.mqttVal(this.titleAll + "/Ib") ?
                            Math.floor(
                                this.$store.getters.mqttVal(this.titleAll + "/Ib") * 100
                            ) / 100 : "--",
                        amount3: this.$store.getters.mqttVal(this.titleAll + "/Ic") ?
                            Math.floor(
                                this.$store.getters.mqttVal(this.titleAll + "/Ic") * 100
                            ) / 100 : "--",
                        amount4: "--",
                        // (this.$store.getters.mqttVal(this.titleAll + "/Ia")
                        //   ? this.$store.getters.mqttVal(this.titleAll + "/Ia")
                        //   : 0) == 0 &&
                        // (this.$store.getters.mqttVal(this.titleAll + "/Ib")
                        //   ? this.$store.getters.mqttVal(this.titleAll + "/Ib")
                        //   : 0) == 0 &&
                        // (this.$store.getters.mqttVal(this.titleAll + "/Ic")
                        //   ? this.$store.getters.mqttVal(this.titleAll + "/Ic")
                        //   : 0) == 0
                        //   ? "--"
                        //   : Math.floor(
                        //       (this.$store.getters.mqttVal(this.titleAll + "/Ia") +
                        //         this.$store.getters.mqttVal(this.titleAll + "/Ib") +
                        //         this.$store.getters.mqttVal(this.titleAll + "/Ic")) *
                        //         100
                        //     ) / 100,

                        spanw: "A",
                    },
                    {
                        id: "4",
                        name: "有功功率",
                        amount1: this.$store.getters.mqttVal(this.titleAll + "/PAa") ?
                            Math.floor(
                                (this.$store.getters.mqttVal(this.titleAll + "/PAa") / 1000) *
                                100
                            ) / 100 : "--",
                        amount2: this.$store.getters.mqttVal(this.titleAll + "/PAb") ?
                            Math.floor(
                                (this.$store.getters.mqttVal(this.titleAll + "/PAb") / 1000) *
                                100
                            ) / 100 : "--",
                        amount3: this.$store.getters.mqttVal(this.titleAll + "/PAc") ?
                            Math.floor(
                                (this.$store.getters.mqttVal(this.titleAll + "/PAc") / 1000) *
                                100
                            ) / 100 : "--",
                        amount4: this.$store.getters.mqttVal(this.titleAll + "/PA") ?
                            Math.floor(
                                (this.$store.getters.mqttVal(this.titleAll + "/PA") / 1000) *
                                100
                            ) / 100 : "--",

                        spanw: "kW",
                    },
                    {
                        id: "5",
                        name: "无功功率",
                        amount1: this.$store.getters.mqttVal(this.titleAll + "/PRa") ?
                            Math.floor(
                                (this.$store.getters.mqttVal(this.titleAll + "/PRa") / 1000) *
                                100
                            ) / 100 : "--",
                        amount2: this.$store.getters.mqttVal(this.titleAll + "/PRb") ?
                            Math.floor(
                                (this.$store.getters.mqttVal(this.titleAll + "/PRb") / 1000) *
                                100
                            ) / 100 : "--",
                        amount3: this.$store.getters.mqttVal(this.titleAll + "/PRc") ?
                            Math.floor(
                                (this.$store.getters.mqttVal(this.titleAll + "/PRc") / 1000) *
                                100
                            ) / 100 : "--",
                        amount4: this.$store.getters.mqttVal(this.titleAll + "/PR") ?
                            Math.floor(
                                (this.$store.getters.mqttVal(this.titleAll + "/PR") / 1000) *
                                100
                            ) / 100 : "--",
                        spanw: "kVar",
                    },
                    {
                        id: "6",
                        amount4: this.$store.getters.mqttVal(this.titleAll + "/P") ?
                            Math.floor(
                                (this.$store.getters.mqttVal(this.titleAll + "/P") / 1000) * 100
                            ) / 100 : "--",
                        name: "视在功率",

                        amount1: this.$store.getters.mqttVal(this.titleAll + "/Pa") ?
                            Math.floor(
                                (this.$store.getters.mqttVal(this.titleAll + "/Pa") / 1000) *
                                100
                            ) / 100 : "--",
                        amount2: this.$store.getters.mqttVal(this.titleAll + "/Pb") ?
                            Math.floor(
                                (this.$store.getters.mqttVal(this.titleAll + "/Pb") / 1000) *
                                100
                            ) / 100 : "--",
                        amount3: this.$store.getters.mqttVal(this.titleAll + "/Pc") ?
                            Math.floor(
                                (this.$store.getters.mqttVal(this.titleAll + "/Pc") / 1000) *
                                100
                            ) / 100 : "--",
                        spanw: "kVA",
                    },
                    {
                        id: "7",
                        name: "电压总谐波",
                        amount1: this.$store.getters.mqttVal(this.titleAll + "/THD_Ua") ?
                            this.$store.getters.mqttVal(this.titleAll + "/THD_Ua") : "--",
                        amount2: this.$store.getters.mqttVal(this.titleAll + "/THD_Ub") ?
                            this.$store.getters.mqttVal(this.titleAll + "/THD_Ub") : "--",
                        amount3: this.$store.getters.mqttVal(this.titleAll + "/THD_Uc") ?
                            this.$store.getters.mqttVal(this.titleAll + "/THD_Uc") : "--",
                        spanw: "%",
                        amount4: "--",
                        //  parseFloat(
                        //   (

                        //   (  this.$store.getters.mqttVal(this.titleAll + "/THD_U")
                        //       ? this.$store.getters.mqttVal(this.titleAll + "/THD_U")
                        //       : 0)

                        //   ).toFixed(2)
                        // ),
                    },
                    {
                        id: "8",
                        name: "电流总谐波",
                        amount1: this.$store.getters.mqttVal(this.titleAll + "/THD_Ia") ?
                            this.$store.getters.mqttVal(this.titleAll + "/THD_Ia") : "--",
                        amount2: this.$store.getters.mqttVal(this.titleAll + "/THD_Ib") ?
                            this.$store.getters.mqttVal(this.titleAll + "/THD_Ib") : "--",
                        amount3: this.$store.getters.mqttVal(this.titleAll + "/THD_Ic") ?
                            this.$store.getters.mqttVal(this.titleAll + "/THD_Ic") : "--",
                        spanw: "%",
                        amount4: "--",
                        //  parseFloat(
                        //   (
                        //      (  this.$store.getters.mqttVal(this.titleAll + "/THD_I")
                        //       ? this.$store.getters.mqttVal(this.titleAll + "/THD_I")
                        //       : 0)

                        //   ).toFixed(2)
                        // ),
                    },
                    {
                        id: "9",
                        name: "母排监测",
                        amount1: this.$store.getters.mqttVal(
                                this.titleAll + "/Temperature_A"
                            ) ?
                            this.$store.getters.mqttVal(
                                this.titleAll + "/Temperature_A"
                            ) : "--",
                        amount2: this.$store.getters.mqttVal(
                                this.titleAll + "/Temperature_B"
                            ) ?
                            this.$store.getters.mqttVal(
                                this.titleAll + "/Temperature_B"
                            ) : "--",
                        amount3: this.$store.getters.mqttVal(
                                this.titleAll + "/Temperature_C"
                            ) ?
                            this.$store.getters.mqttVal(
                                this.titleAll + "/Temperature_C"
                            ) : "--",
                        spanw: "℃",
                        amount4: "- -",
                    },
                ];
            },
        },
        watch: {
            infoSts(n, o) {
                this.ShareTheState();
            },
            error(n, o) {
                this.ShareTheState();
            },
            Yufa(n, o) {
                this.ShareTheState();
            },
            statusNum(n, o) {
                this.ShareTheState();
            },
            titleAll(n) {
                this.titleAll = n;
                subscribe([n]);
                this.ShareTheState();
            },
            loop(n) {
                this.loop = n;
            },
            titleId(n, o) {
                this.initEcharts();
                this.initEcharts1();
                this.initEcharts2();
            },
            "$store.state.subLoopUrl.valuer": function (n, o) {

                this.ShareTheState();
                //    timerJack: 6,
                //     timecuke: 5,
                if ((this.timerJack == 6 || this.timerJack == 0) && (this.timecuke == 5 || this.timecuke == 0)) {
                    this.ShareTheState();
                }

            },
            "$store.state.subLoopUrl.getstatus": function (n, o) {
                this.ShareTheState();
            },
        },

        beforeCreate() {
            connectMqtt();
        },
        created() {
            //初始值赋值
            // this.titleAll = this.$store.state.subLoopUrl.LoopUrl;
            this.loop = this.$store.state.subLoopUrl.Loop;
            subscribe([this.titleAll]);
        },
        mounted() {
            this.appAll();
            // this.titleId = 2;
            
            this.ShareTheState();
            this.timer = setInterval(() => {
                this.initEcharts();
                this.initEcharts1();
                this.initEcharts2();
            }, 300000);
            //第一图
            this.initEcharts();
            this.initEcharts1();
        },

        beforeRouteLeave(to, form, next) {
            window.localStorage.setItem(
                "currentLoop",
                JSON.stringify(this.currentLoopDetails)
            );
            window.localStorage.setItem(
                "index",
                this.current
            );
            this.$store.commit("scrollTop", this.top)
            next();
        },

        // activated() {
        //     let loopStr = window.localStorage.getItem("currentLoop");
        //     this.currentLoopDetails = JSON.parse(loopStr);
        //     setTimeout(() => {
        //         this.$refs.nav.scrollTop = this.currentLoopDetails.height;
        //     }, 300);
        //     this.title = this.currentLoopDetails.loopName;
        //     this.titleId = this.currentLoopDetails.loopId;
        //     this.titleAll = this.currentLoopDetails.subLoopUrl;
        //     this.src = this.currentLoopDetails.loopMap;
        //     this.current = this.currentLoopDetails.loopId
        //     if (this.currentLoopDetails.hasOwnProperty("errorStatus")) {
        //         this.error = this.currentLoopDetails.errorStatus;
        //     } else {
        //         this.error = ""
        //         this.faultStatus = false;
        //     }
        //     if (this.currentLoopDetails.hasOwnProperty("distantStatus")) {
        //         this.locallyStatus = this.currentLoopDetails.distantStatus;
        //     } else {
        //         this.locallyStatus = ""
        //         // this.jiu = "- -";
        //         // this.yuan = "- -";
        //     }
        //     if (this.currentLoopDetails.hasOwnProperty("switchStatus")) {
        //         this.statusNum = this.currentLoopDetails.switchStatus;
        //         this.$store.commit("statuLoop", this.currentLoopDetails.switchStatus);
        //     } else {
        //         this.statusNum = ""
        //         this.statul = "- -";
        //         this.onChan = "po";
        //         this.onage = "po";
        //     }
        //     if (this.currentLoopDetails.switchOff) {
        //         this.FnzNum = this.currentLoopDetails.switchOff;
        //     }
        //     if (this.currentLoopDetails.switchOn) {
        //         this.HezNum = this.currentLoopDetails.switchOn;
        //     }
        //     this.ShareTheState()
        // },
        beforeDestroy() {
            clearInterval(this.timer);
            unsubscribe([this.titleAll]);
        },
        methods: {
            clikcLoopAll() {
                this.drawer = true
                setTimeout(() => {
                    if (this.bgonClick[0].loopId == this.current) {
                        this.$refs.nav.scrollTop = 0
                    } else {
                        this.$refs.nav.scrollTop = this.currentLoopDetails.height;
                    }

                }, 300);
            },
            scrool() {
                this.top = this.$refs.nav.scrollTop;
                this.$store.commit("scrollTop", this.top)
            },
            //点击滚动条事件
            roll(index) {
                if (index == 2) {
                    //滚动的数值  或者  +- = 值  或者死的数值 就是相应位置
                    //还有相应的 scrollTop 方法
                    this.$refs.nav.scrollTop += 100;
                } else {
                    this.$refs.nav.scrollTop -= 100;
                }
            },
            //所有回路接口
            appAll() {
                chainIndex
                    .analogInterface(this.$store.state.proproT.AllId)
                    .then((res) => {
                        this.bgonClick = res.data.data.deviceLoops.filter(item => {

                            if (item.loopId != 205 && item.loopId != 297) {
                                return item
                            }
                        });

                        this.current = this.bgonClick[0].loopId;

                        this.titleId = this.bgonClick[0].loopId;
                        this.titleAll = this.bgonClick[0].subLoopUrl;
                        this.title = this.bgonClick[0].loopName;
                        this.src = this.bgonClick[0].loopMap;
                        if (this.bgonClick[0].errorStatus) {
                            this.error = this.bgonClick[0].errorStatus;
                        } else {
                            this.error = ""
                        }
                        if (this.bgonClick[0].switchStatus) {

                            this.statusNum = this.bgonClick[0].switchStatus;
                        } else {
                            this.statusNum = ""
                        }
                        if (this.bgonClick[0].switchOff) {
                            this.FnzNum = this.bgonClick[0].switchOff;
                        }
                        if (this.bgonClick[0].switchOn) {
                            this.HezNum = this.bgonClick[0].switchOn;
                        }
                        if (this.bgonClick[0].distantStatus) {
                            this.locallyStatus = this.bgonClick[0].distantStatus;
                        } else {
                            this.locallyStatus = ""
                        }

                        // this.src = require("../assets/img/1_回路.svg");
                    });
            },
            //点击事件
            add(index, item) {
                item.height = this.$refs.nav.scrollTop
                this.top = this.$refs.nav.scrollTop;
                this.$store.commit("scrollTop", this.top)
                this.currentLoopDetails = item;
                this.current = index
                if (index) {
                    window.suburl = item.subLoopUrl;
                    this.drawer = false;
                    window.sessionStorage.setItem("setTitle", item);
                    //vueBus传参
                    this.title = item.loopName;
                    this.$root.eventHub.$emit("YOUR_EVENT_NAME", item);
                    //改变回路订阅值
                    this.titleAll = item.subLoopUrl;
                    this.$store.commit("LoopUrlTS", item.loopUrl);
                    this.loop = item.loopUrl;
                    //获取ID
                    this.titleId = item.loopId;
                    this.$store.commit("changeValue", "abc");
                    if (item.hasOwnProperty("errorStatus")) {
                        this.error = item.errorStatus;
                    } else {
                        this.error = ""
                        this.faultStatus = false;
                    }
                    if (item.hasOwnProperty("distantStatus")) {
                        this.locallyStatus = item.distantStatus;
                    } else {
                        this.locallyStatus = ""
                        // this.jiu = "- -";
                        // this.yuan = "- -";
                    }
                    if (item.hasOwnProperty("switchStatus")) {
                        this.statusNum = item.switchStatus;
                        this.$store.commit("statuLoop", item.switchStatus);
                    } else {
                        this.statusNum = ""
                        this.statul = "- -";
                        this.onChan = "po";
                        this.onage = "po";
                    }
                    if (item.switchOff) {
                        this.FnzNum = item.switchOff;
                    }
                    if (item.switchOn) {
                        this.HezNum = item.switchOn;
                    }
                    this.ShareTheState()
                } else {
                    this.locallyStatus = "";
                }
                this.src = item.loopMap;
            },
            //确认分闸操作
            onPo() {
                const h = this.$createElement;
                this.dialogVisible = true;
                this.$confirm({}, "操作确认", {
                        cancelButtonText: "取消",
                        confirmButtonText: "确定",
                        // type: "warning",
                        // style:"font-weight: 700",
                        message: h("p", null, [
                            h("span", {
                                style: " font-size:18rem"
                            }, "你即将进行"),
                            h("b", {
                                style: "color: teal; font-size:18rem"
                            }, "分闸"),
                            h("span", {
                                style: " font-size:18rem"
                            }, "操作 !"),
                        ]),
                    })
                    .then(() => {

                        if (this.dialogVisible) {
                            this.percentageFn = 0;
                            this.percentageHe = 0;
                            let timer = setInterval(() => {
                                this.percentageHe += 20;
                                this.onChan = "po";
                                this.onage = "po";
                                (this.Hez = this.timecuke), (this.statul = "合闸");
                                this.st = "ored";
                                this.timecuke--;
                                if (this.timecuke < 0) {
                                    this.onChan = "po";
                                    this.onage = "clo";
                                    this.statul = "分闸";
                                    this.st = "ogreen";
                                    this.Hez = "合闸";
                                    this.percentageHe = 0;
                                    clearInterval(timer);
                                    this.ShareTheState();
                                    // if (this.statul == "分闸") {
                                    //     this.$message({
                                    //         type: "success",
                                    //         message: "分闸操作成功!",
                                    //     });
                                    // } else {
                                    //     this.$message.error('分闸操作失败!');
                                    // }
                                }
                            }, 1000);
                            this.timecuke = 5;
                            publishFun(this.loop, this.FnzNum, 1);
                            // chainIndex.totayTg(
                            //     22,
                            //     "OPENING_AND_CLOSING",
                            //     1,
                            //     this.loop,
                            //     Date.parse(new Date()),
                            //     this.statusNum,
                            //     this.$store.state.proproT.AllId,
                            //     Date.parse(new Date()),
                            //     "WARNING"
                            // );
                        }
                    })
                    .catch(() => {
                        // this.$message({
                        //     type: "info",
                        //     message: "已取消操作",
                        // });
                    });
            },
            //确认合闸操作
            onClo() {
                const h = this.$createElement;
                this.dialogVisible = true;
                this.$confirm("", "操作确认", {
                        cancelButtonText: "取消",
                        confirmButtonText: "确定",
                        message: h("p", null, [
                            h("span", {
                                style: " font-size:18rem；"
                            }, "你即将进行"),
                            h("b", {
                                style: "color: red; font-size:18rem"
                            }, "合闸"),
                            h("span", {
                                style: "font-size:18rem"
                            }, "操作 !"),
                        ]),
                    })
                    .then(() => {
                        if (this.dialogVisible) {
                            this.percentageFn = 0;
                            this.percentageHe = 0;

                            let time = setInterval(() => {
                                this.onChan = "po";
                                this.onage = "po";
                                this.statul = "分闸";
                                this.st = "ogreen";
                                this.percentageFn += 20;
                                this.timerJack--;
                                this.Fnz = this.timerJack;
                                if (this.timerJack <= 0) {
                                    this.onChan = "clo";
                                    this.onage = "po";
                                    this.statul = "合闸";
                                    this.st = "ored";
                                    this.Fnz = "分闸";
                                    clearInterval(time);
                                    this.ShareTheState();
                                    this.percentageFn = 0;
                                    // if (this.statul == "合闸") {
                                    //     this.$message({
                                    //         type: "success",
                                    //         message: "合闸操作成功!",
                                    //     });
                                    // } else {
                                    // this.$message.error('合闸操作失败!');
                                    // }
                                }
                            }, 1000);
                            this.timerJack = 6;
                            publishFun(this.loop, this.HezNum, 1);
                            // chainIndex.totayTg(
                            //     22,
                            //     "OPENING_AND_CLOSING",
                            //     2,
                            //     this.loop,
                            //     Date.parse(new Date()),
                            //     this.statusNum,
                            //     this.$store.state.proproT.AllId,
                            //     Date.parse(new Date()),
                            //     "WARNING"
                            // );
                        }

                    })
                    .catch(() => {
                        // this.$message({
                        //     type: "info",
                        //     message: "已取消操作",
                        // });
                    });
            },

            //分合闸状态渲染
            ShareTheState() {
                window.suburl = this.titleAll;
                if (this.$store.getters.mqttVal(this.error) == "True"||this.$store.getters.mqttVal(this.error) >0) {
                    this.onChan = "po";
                    this.onage = "po";
                    this.st = "obalck";
                    this.statul = "- -";
                    this.faultStatus = true;
                } else {
                    this.faultStatus = false;
                    if (this.$store.getters.mqttVal(this.statusNum) == "True"||this.$store.getters.mqttVal(this.statusNum) >0) {
                        this.percentageFn = 0;
                        this.percentageHe = 0;
                        this.onChan = "clo";
                        this.onage = "po";
                        this.statul = "合闸";
                        this.st = "ored";
                        this.$store.commit("changeValue", "1");
                        if (this.Yufa == "True"||this.Yufa >0) {
                            this.percentageFn = 0;
                            this.percentageHe = 0;
                            this.onChan = "clo";
                            this.onage = "po";
                            this.statul = "合闸";
                            this.st = "ored";
                            this.$store.commit("changeValue", "1");
                        } else {
                            this.onChan = "po";
                            this.statul = "合闸";
                            this.onage = "po";
                            this.st = "ored";
                        }
                    } else if (this.$store.getters.mqttVal(this.statusNum) == "False"||this.$store.getters.mqttVal(this.statusNum) <=0) {
                        this.percentageFn = 0;
                        this.percentageHe = 0;
                        this.onChan = "po";
                        this.onage = "clo";
                        this.statul = "分闸";
                        this.st = "ogreen";
                        this.$store.commit("changeValue", "0");
                        if (this.Yufa == "True"||this.Yufa>0 ) {
                            this.percentageFn = 0;
                            this.percentageHe = 0;
                            this.onChan = "po";
                            this.onage = "clo";
                            this.statul = "分闸";
                            this.st = "ogreen";
                            this.$store.commit("changeValue", "0");
                        } else {
                            this.onChan = "po";
                            this.onage = "po";
                            this.statul = "分闸";
                            this.st = "ogreen";
                        }
                    } else {
                        this.onChan = "po";
                        this.onage = "po";
                        this.statul = "- -";
                        this.st = "obalck";
                    }
                }
            },
            initEcharts() {
                //   let echarts = require("echarts");
                this.myChart = echarts.init(this.$refs.echartsDom);
                var Pro = ["product"];
                var Aro = ["A相"];
                var Bro = ["B相"];
                var Cro = ["C相"];
                this.myChart.setOption({
                    color: ["#5B8FF9", "#5AD8A6", "#5D7092"],
                    legend: {
                        itemWidth: 16,
                        itemHeight: 16,
                        x: "center",
                        type: "plain",
                        icon: "square", //正方形图例
                        data: ["A相", "B相", "C相"],
                        left: "right", // 图例的位置
                        textStyle: {
                            color: "#999999",
                        },
                    },
                    title: {
                        text: "电流曲线",
                    },
                    dataset: {
                        source: [Pro, Aro, Bro, Cro],
                    },
                    grid: {
                        top: "26%",
                        right: "5%",
                        bottom: "11%",
                    },
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            animation: true,
                        },

                        textStyle: {
                            //图例文字的样式
                            color: "bolck", //文字颜色
                            fontSize: 12, //文字大小
                        },
                    },
                    xAxis: {
                        type: "category",
                        boundaryGap: false,
                        axisLine: {
                            lineStyle: {
                                color: "rgba(0,0,0,0.06)"
                            }, // x轴坐标轴颜色
                        },
                        axisLabel: {
                            color: "#333333"
                        }, // x轴字体颜色
                        axisLine: {
                            lineStyle: {
                                color: "rgba(0,0,0,0.06)",
                            },
                            //y轴不显示
                            show: true,
                            //箭头
                            symbol: ["none", "arrow"],
                            symbolOffset: 12,
                            symbolSizi: [45, 45],
                        },
                    },

                    yAxis: {
                        axisLine: {
                            // color: "rgba(0,0,0,0.06)",
                            lineStyle: {
                                color: "rgba(0,0,0,0.06)"
                            }, //y轴坐标轴颜色
                        },
                        axisLabel: {
                            color: "#333333"
                        }, //y轴字体颜色

                        type: "value",
                        splitNumber: 5,
                        splitLine: {
                            lineStyle: {
                                color: "rgba(0,0,0,0.06)",
                            },
                        },
                        axisLine: {
                            lineStyle: {
                                color: "rgba(0,0,0,0.06)",
                            },
                            //y轴不显示
                            show: true,
                            //箭头
                            symbol: ["none", "arrow"],
                            symbolOffset: 12,
                            symbolSizi: [45, 45],
                        },
                    },

                    series: [{
                            type: "line",
                            smooth: true,
                            connectNulls: true,
                            seriesLayoutBy: "row",
                        },
                        {
                            type: "line",
                            smooth: true,
                            connectNulls: true,
                            seriesLayoutBy: "row",
                        },
                        {
                            type: "line",
                            smooth: true,
                            connectNulls: true,
                            seriesLayoutBy: "row",
                        },
                    ],
                });

                chainIndex
                    .echartsB(this.titleId, this.tm(), "Ia,Ib,Ic", this.outtm(), "1h")
                    .then((res) => {
                        if(JSON.stringify(res.data.data.points)!="{}"){
                            res.data.data.points["Ia"].forEach((item, index) => {
                                let cop = item.time.split("T");
                                let copo = cop[1].split(":");
                                if (copo[0] % 2 == 0 && this.hours % 2 == 0) {
                                    Pro.push(copo[0] + "点");
                                    Aro.push(item.val);
                                } else if (copo[0] % 2 != 0 && this.hours % 2 != 0) {
                                    Pro.push(copo[0] + "点");
                                    Aro.push(item.val);
                                }
                            });
                            res.data.data.points["Ib"].forEach((item, index) => {
                                let cop = item.time.split("T");
                                let copo = cop[1].split(":");
                                if (copo[0] % 2 == 0 && this.hours % 2 == 0) {
                                    Bro.push(item.val);
                                } else if (copo[0] % 2 != 0 && this.hours % 2 != 0) {
                                    Bro.push(item.val);
                                }
                            });
                            res.data.data.points["Ic"].forEach((item, index) => {
                                let cop = item.time.split("T");
                                let copo = cop[1].split(":");
                                if (copo[0] % 2 == 0 && this.hours % 2 == 0) {
                                    Cro.push(item.val);
                                } else if (copo[0] % 2 != 0 && this.hours % 2 != 0) {
                                    Cro.push(item.val);
                                }
                            });
                            this.myChart.setOption({
                                dataset: {
                                    source: [Pro, Aro, Bro, Cro],
                                },
                            });
                        }
                        
                    });

                window.addEventListener("resize", () => {
                    this.myChart.resize();
                });
            },
            //当前时间戳
            tm() {
                //获取当前时间
                var date = new Date();
                var year = date.getFullYear();
                var month =
                    date.getMonth() + 1 < 10 ?
                    "0" + (date.getMonth() + 1) :
                    date.getMonth() + 1;
                var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
                var hours =
                    date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
                this.hours = hours;
                return `${year}-${month}-${day}T${hours}:00:00Z`;
            },
            //12小时前时间戳
            outtm() {
                //获取当前时间
                var date = new Date().getTime();
                var timer = new Date(date - 12 * 60 * 60 * 1000);
                var year = timer.getFullYear();
                var month =
                    timer.getMonth() + 1 < 10 ?
                    "0" + (timer.getMonth() + 1) :
                    timer.getMonth() + 1;
                var day = timer.getDate() < 10 ? "0" + timer.getDate() : timer.getDate();

                var hours =
                    timer.getHours() < 10 ? "0" + timer.getHours() : timer.getHours();
                return `${year}-${month}-${day}T${hours}:00:00Z`;
            },
            initEcharts1() {
                //   let echarts1 = require("echarts");
                this.myChart1 = echarts.init(this.$refs.echartsDom1);
                var Pro = ["product"];
                var Aro = ["A相"];
                var Bro = ["B相"];
                var Cro = ["C相"];
                this.myChart1.setOption({
                    color: ["#5B8FF9", "#5AD8A6", "#5D7092"],
                    legend: {
                        itemWidth: 16,
                        itemHeight: 16,
                        x: "center",
                        type: "plain",
                        icon: "square", //正方形图例
                        data: ["A相", "B相", "C相"],
                        left: "right", // 图例的位置
                        textStyle: {
                            color: "#999999",
                        },
                    },
                    title: {
                        text: "电压曲线",
                    },
                    dataset: {
                        source: [Pro, Aro, Bro, Cro],
                    },
                    grid: {
                        top: "26%",
                        right: "5%",
                        bottom: "11%",
                    },
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            animation: true,
                        },

                        textStyle: {
                            //图例文字的样式
                            color: "bolck", //文字颜色
                            fontSize: 12, //文字大小
                        },
                    },

                    xAxis: {
                        type: "category",
                        boundaryGap: false,
                        axisLine: {
                            lineStyle: {
                                color: "rgba(0,0,0,0.06)"
                            }, // x轴坐标轴颜色
                        },
                        axisLabel: {
                            color: "#333333"
                        }, // x轴字体颜色
                        axisLine: {
                            lineStyle: {
                                color: "rgba(0,0,0,0.06)",
                            },
                            //y轴不显示
                            show: true,
                            //箭头
                            symbol: ["none", "arrow"],
                            symbolOffset: 12,
                            symbolSizi: [45, 45],
                        },
                    },

                    yAxis: {
                        axisLine: {
                            // color: "rgba(0,0,0,0.06)",
                            lineStyle: {
                                color: "rgba(0,0,0,0.06)"
                            }, //y轴坐标轴颜色
                        },
                        axisLabel: {
                            color: "#333333"
                        }, //y轴字体颜色

                        type: "value",
                        splitNumber: 5,
                        splitLine: {
                            lineStyle: {
                                color: "rgba(0,0,0,0.06)",
                            },
                        },
                        axisLine: {
                            lineStyle: {
                                color: "rgba(0,0,0,0.06)",
                            },
                            //y轴不显示
                            show: true,
                            //箭头
                            symbol: ["none", "arrow"],
                            symbolOffset: 12,
                            symbolSizi: [45, 45],
                        },
                    },
                    series: [{
                            type: "line",
                            smooth: true,
                            connectNulls: true,
                            seriesLayoutBy: "row",
                        },
                        {
                            type: "line",
                            smooth: true,
                            connectNulls: true,
                            seriesLayoutBy: "row",
                        },
                        {
                            type: "line",
                            smooth: true,
                            connectNulls: true,
                            seriesLayoutBy: "row",
                        },
                    ],
                });
                chainIndex
                    .echartsB(this.titleId, this.tm(), "Ua,Ub,Uc", this.outtm(), "1h")
                    .then((res) => {
                        if(JSON.stringify(res.data.data.points)!="{}"){
                            res.data.data.points["Ua"].forEach((item, index) => {
                                let cop = item.time.split("T");
                                let copo = cop[1].split(":");
                                if (copo[0] % 2 == 0 && this.hours % 2 == 0) {
                                    Pro.push(copo[0] + "点");
                                    Aro.push(item.val);
                                } else if (copo[0] % 2 != 0 && this.hours % 2 != 0) {
                                    Pro.push(copo[0] + "点");
                                    Aro.push(item.val);
                                }
                            });


                            res.data.data.points["Ub"].forEach((item, index) => {
                                let cop = item.time.split("T");
                                let copo = cop[1].split(":");
                                if (copo[0] % 2 == 0 && this.hours % 2 == 0) {
                                    Bro.push(item.val);
                                } else if (copo[0] % 2 != 0 && this.hours % 2 != 0) {
                                    Bro.push(item.val);
                                }
                            });
                            res.data.data.points["Uc"].forEach((item, index) => {
                                let cop = item.time.split("T");
                                let copo = cop[1].split(":");
                                if (copo[0] % 2 == 0 && this.hours % 2 == 0) {
                                    Cro.push(item.val);
                                } else if (copo[0] % 2 != 0 && this.hours % 2 != 0) {
                                    Cro.push(item.val);
                                }
                            });
                            this.myChart1.setOption({
                                dataset: {
                                    source: [Pro, Aro, Bro, Cro],
                                },
                            });
                        }
                        
                    });
                window.addEventListener("resize", () => {
                    this.myChart1.resize();
                });
            },

            initEcharts2() {
                this.totalAll = parseFloat(
                    (
                        (((this.$store.getters.mqttVal(this.titleAll + "/Ia") ?
                                    this.$store.getters.mqttVal(this.titleAll + "/Ia") :
                                    0) +
                                (this.$store.getters.mqttVal(this.titleAll + "/Ib") ?
                                    this.$store.getters.mqttVal(this.titleAll + "/Ib") :
                                    0) +
                                (this.$store.getters.mqttVal(this.titleAll + "/Ic") ?
                                    this.$store.getters.mqttVal(this.titleAll + "/Ic") :
                                    0)) /
                            3 /
                            ((this.$store.getters.mqttVal(this.titleAll + "/Ia") ?
                                    this.$store.getters.mqttVal(this.titleAll + "/Ia") :
                                    0) +
                                (this.$store.getters.mqttVal(this.titleAll + "/Ib") ?
                                    this.$store.getters.mqttVal(this.titleAll + "/Ib") :
                                    0) +
                                (this.$store.getters.mqttVal(this.titleAll + "/Ic") ?
                                    this.$store.getters.mqttVal(this.titleAll + "/Ic") :
                                    0))) *
                        100
                    ).toFixed(1)
                );
                this.itemP = parseFloat(
                    (
                        (((this.$store.getters.mqttVal(this.titleAll + "/Ia") ?
                                    this.$store.getters.mqttVal(this.titleAll + "/Ia") :
                                    0) +
                                (this.$store.getters.mqttVal(this.titleAll + "/Ib") ?
                                    this.$store.getters.mqttVal(this.titleAll + "/Ib") :
                                    0) +
                                (this.$store.getters.mqttVal(this.titleAll + "/Ic") ?
                                    this.$store.getters.mqttVal(this.titleAll + "/Ic") :
                                    0)) /
                            3 /
                            Math.max(
                                this.$store.getters.mqttVal(this.titleAll + "/Ia"),
                                this.$store.getters.mqttVal(this.titleAll + "/Ib"),
                                this.$store.getters.mqttVal(this.titleAll + "/Ic")
                            )) *
                        100
                    ).toFixed(2)
                );

                //   let echarts2 = require("echarts");
                this.myChart2 = echarts.init(this.$refs.echartsDom2);
                this.myChart2.setOption({
                    title: [{
                        text: "回路负载率",
                    }, ],
                    tooltip: {
                        trigger: "item",
                        // formatter: `{a} <br/>{b}: {c} ({d}%)`,
                    },

                    //圆环的颜色
                    color: ["#E8684A", "#6DC8EC"],
                    series: [{
                        top: "7%",
                        //代表a的值，系列名称
                        type: "pie",
                        data: [{
                                value: `${this.totalAll ? this.totalAll : 0}`,
                                name: "总负载率",
                            },
                            {
                                value: `${this.itemP ? this.itemP : 0}`,
                                name: "回路负载率"
                            },
                        ],
                        center: ["24%", "50%"], //饼图的中心（圆心）坐标，数组的第一项是横坐标，第二项是纵坐标。
                        radius: ["45%", "60%"], //饼图的半径，数组的第一项是内半径，第二项是外半径。[ default: [0, '75%'] ]
                        avoidLabelOverlap: false, //是否禁用动画效果

                        label: {
                            show: false, //是否显示标签

                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: "rgba(0, 0, 0, 0.5)",
                                },
                            },
                        },
                        labelLine: {
                            position: "inner", //隐藏引导线
                            show: false, //隐藏标识文字
                        },
                        // 系列中的数据内容数组。
                    }, ],
                });
                window.addEventListener("resize", () => {
                    this.myChart2.resize();
                });
            },
            //改变表头
            //改变table颜色
            tableHeaderColor({
                row,
                column,
                rowIndex,
                columnIndex
            }) {
                if (rowIndex === 0) {
                    return "background-color:rgba(0, 0, 0,0.06);color: #000000;font-weight: 700;";
                }
            },
            //表格颜色
            //改变table颜色
            tableRowClassName({
                rowIndex
            }) {
                if (rowIndex % 2 != 0) {
                    //=>这里可以改成 rowIndex%2=== 1，后面直接else即可达到隔行变色效果。
                    return "warning-row";
                }
                return "";
            },
        },
    };
</script>
<style lang="less" scoped>
    .head {
        width: 100%;
        height: 48rem;
        display: flex;
        margin-bottom: 24rem;

        .name {
            width: 440rem;
            height: 100%;
            background: #ffffff;
            display: flex;
            // padding: 12rem 17rem 0 24rem;
            justify-content: center;
            align-items: center;

            .spa {
                // width: 252rem;
                font-size: 26rem;
                font-weight: 400;
                color: #333333;
                margin-left: 17rem;
                font-weight: 400;
                // line-height: 44rem;
                font-family: "YouSheBiaoTiHei-2";
                text-align: center;
                // display: flex;
                // align-items: center;
            }

            .oimg {
                width: 24rem;
                height: 24rem;

                img {
                    width: 24rem;
                    height: 24rem;
                }
            }
        }

        .tatel {
            width: 560rem;
            height: 48rem;
            background: #ffffff;
            border: 1rem solid rgba(0, 0, 0, 0.01);
            padding: 12rem 0 12rem 24rem;
            box-shadow: 0rem 3rem 14rem 0rem rgba(3, 13, 24, 0.26);
            border-radius: 0rem 0rem 8rem 8rem;
            display: flex;
            align-items: center;
            text-align: center;

            .miti {
                width: 22rem;
                height: 22rem;

                i {
                    font-size: 22rem;
                    color: chocolate;
                }
            }

            .mixin {
                margin-left: 18rem;
                font-size: 24rem;
                font-weight: 400;
                margin-top: -2rem;
                // color: #cccccc;
                color: #666666;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }

    .about {
        width: 100%;
        height: 100%;
    }

    .about1 {
        display: flex;
        //   flex-flow: column;
        //   justify-content: space-between;
        padding: 0 24rem;

        .infinite-list {
            height: 900rem;
        }

        // .infinite-list::-webkit-scrollbar {
        //   display: none;
        // }
        .Pngfute {
            width: 330rem;
            height: 602rem;
            background-image: url(../assets/img/bg.png);
            // border-bottom: 1rem solid black;
            padding: 25rem 0;
            background-size: 100% 100%;

            .oimg {
                width: 280rem;
                height: 552rem;
                background-color: #fff;
                margin: auto;
            }

            img {
                width: 100%;
                height: 100%;
            }
        }

        .state {
            margin-top: -2rem;
            background-image: url(../assets/img/倒影@2x.png);
            background-size: 100% 100%;
            background-repeat: no-repeat;
            width: 330rem;
            height: 53rem;
            margin-bottom: 6rem;
            display: flex;
            justify-content: center;

            .ored {
                color: #fd4238;
            }

            .ogreen {
                color: #01ab65;
                // background-color:green;
            }

            .setState {
                width: 100%;
                height: 51rem;
                background-image: url(../assets/img/aftstate.png);
                background-repeat: no-repeat;
                background-size: 100% 57rem;
                font-size: 12rem;
                //   margin: auto;
                display: flex;
                justify-content: space-around;
                padding: 0 25rem;
                align-items: center;
            }

            .setState3,
            .setState2,
            .setState4,
            .setState1 {
                height: 51rem;
                position: relative;
                display: flex;
                align-items: center;
            }

            .gzzt {
                font-size: 18rem;
                color: #fd4238;
                position: absolute;
                right: -180rem;
                line-height: 30rem;
                display: flex;
                align-items: center;

                img {
                    width: 30rem;
                    height: 26rem;
                    margin-right: 8rem;
                }
            }

            .setState2 {
                color: #333333;
            }

            .setState3 {
                color: #333333;
            }

            .setState4 {
                color: #333333;
            }
        }

        .bar {
            width: 100%;
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: center;

            align-items: center;
            padding: 0 46rem;
            // text-align: center;

            .clo {
                position: relative;
                border-radius: 50%;
                background-image: url(../assets/img/botton1.png);
                width: 80px;
                height: 80px;
                cursor: pointer;
                background-size: 80px 80px;
                font-size: 24rem;
                font-weight: 500;
                color: #ffffff;
                line-height: 80px;
            }

            .po {
                position: relative;
                border-radius: 50%;
                width: 80px;
                height: 80px;
                color: #ffffff;
                background: url(../assets/img/botton2.png) center no-repeat;
                //   background-repeat: no-repeat;
                background-size: 80px 80px;
                font-size: 24rem;
                font-weight: 500;
                // color: #ffffff;
                line-height: 80px;
                //  cursor: no-drop;
                pointer-events: none;
            }
        }

        .middle {
            margin-left: 15rem;

            .table {
                width: 586rem;
                height: 540rem;
                // margin-bottom: 124rem;
            }

            .table-head {
                width: 586rem;
                height: 54rem;
                text-align: center;
                // margin-bottom: 124rem;
            }

            td {
                width: 97rem;
            }

            .table-fool {
                width: 586rem;
                height: 486rem;
                text-align: center;
            }

            .trigger {
                width: 195rem;
                height: 81rem;
                background-image: url(../assets/img/btnstuts.png);
                background-size: 195rem 81rem;
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                padding: 0rem 18rem 10rem 0;
                margin-top: 128rem;

                .jadk {
                    text-align: center;
                    line-height: 50rem;
                    border-bottom: 1rem solid rgb(209, 206, 206);
                }

                // .jadk:hover {
                //     //  box-shadow: 20rem 10rem 20rem rgb(214, 210, 210);
                //     // box-shadow: 5rem 1rem 10rem gray;
                // }
                .array {
                    color: #ffffff;
                    background-color: #5b8ff9;
                    box-shadow: 5rem 1rem 10rem #5b8ff9;
                    border-bottom: 1rem solid #5b8ff9;
                }

                .el-icon-sort {
                    font-size: 22rem;
                }

                .swtrGet {
                    font-size: 24rem;
                    font-weight: 500;
                    color: #333333;
                    margin-left: 8rem;
                    cursor: pointer;
                }
            }
        }

        .dexter {
            margin-left: 30rem;

            .oia {
                margin-bottom: 38rem;

                .myCharts {
                    width: 424rem;
                    height: 234rem;
                    margin-bottom: 31rem;
                }
            }

            .oib {
                margin-bottom: 38rem;

                .myCharts1 {
                    width: 424rem;
                    height: 234rem;
                }
            }

            .opl {
                position: relative;

                .myCharts2 {
                    width: 336rem;
                    height: 216rem;
                }

                .myCharts2-text {
                    width: 80rem;
                    color: #333333;
                    font-size: 22rem;
                    font-weight: normal;
                    position: absolute;
                    top: 40%;
                    left: 10%;
                    text-align: center;
                }

                .myCharts3-text {
                    width: 80rem;
                    color: #a6a8b6;
                    font-size: 18rem;
                    font-weight: normal;
                    position: absolute;
                    top: 52%;
                    left: 10%;
                    text-align: center;
                }

                .pink {
                    width: 10rem;
                    height: 10rem;
                    background-color: #e8684a;
                }

                .gruen {
                    width: 10rem;
                    height: 10rem;
                    background-color: #6dc8ec;
                }

                .PngUl {
                    position: absolute;
                    top: 40rem;
                    left: 160rem;
                }

                .pngLi {
                    width: 220rem;
                    display: flex;
                    align-items: center;
                    color: #333333;
                }

                p:last-child {
                    float: left;
                    padding-left: 20rem;
                    font-size: 16rem;
                    font-weight: 400;
                    color: #333333;
                }
            }
        }

        .upward {
            position: absolute;
            width: 100%;
            height: 50rem;
            top: 0;
            background-color: #ffffff;
            text-align: center;
            font-size: 28rem;
            line-height: 50rem;
            border-bottom: 1rem solid rgba(128, 128, 128, 0.4);
            z-index: 9999;
        }

        .downward {
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 50rem;
            background-color: #fff;
            text-align: center;
            line-height: 50rem;
            font-size: 28rem;
            border-top: 1rem solid rgba(128, 128, 128, 0.4);
            z-index: 9999;
        }

        .vue-drag-scroll-out-wrapper::-webkit-scrollbar {
            display: none;
        }

        .vue-drag-scroll-out-wrapper {
            width: 100%;
            overflow-x: hidden;
            /* width: 100%; */

            cursor: grab;
            position: absolute;
            top: 0;
            left: 0;
            padding-top: 50rem;
        }

        .nonum {
            text-align: center;
            padding-bottom: 0rem;
            // padding-top: 20rem;
            color: rgb(189, 189, 189, 0.5);
            padding-top: 240rem;
        }

        .npiNum {
            padding-bottom: 430rem;
            text-align: center;
            padding-top: 40rem;
            color: rgb(189, 189, 189, 0.5);
        }

        // .mar {
        //   margin: auto;
        //   .tors {
        //     width: 400rem;
        //     height: 400rem;
        //     margin: auto;
        //     // background-color: red;
        //     text-align: center;
        //     img {
        //       margin-top: 88rem;
        //       margin-right: 80rem;
        //       margin-left: 80rem;
        //     }
        //     .oP {
        //       font-size: 18rem;
        //       font-weight: 400;
        //       color: #999999;
        //       margin-top: 24rem;
        //     }
        //   }
        // }
        .fors {
            display: flex;
            // text-align: center;
        }
    }

    .antfos {
        color: #0d94ff;
    }

    .po {
        position: relative;
        width: 80px !important;
        height: 80px !important;
    }

    .text-btn {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 100%;
        text-align: center;
        transform: translate(-50%, -50%);
        display: inline !important;
        font-size: 24rem !important;
        line-height: 24rem !important;
    }

    .antfos {
        color: #0d94ff;
    }
</style>